// extracted by mini-css-extract-plugin
export default {"root":"styles_root__jDQ-s","title":"styles_title__905Ib","description":"styles_description__KGy58"};